// src/main.js
import { createApp, provide, h } from 'vue';
import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client/core';
import { DefaultApolloClient } from '@vue/apollo-composable';

import App from './App.vue';
import 'vuetify/styles'; // Ensure you are importing Vuetify styles correctly
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components'; // Import all Vuetify components
import * as directives from 'vuetify/directives'; // Import all Vuetify directives
import { load } from 'webfontloader';
import '@mdi/font/css/materialdesignicons.css'
import router from './router/router';

// Example configuration to load Google Fonts
load({
  google: {
    families: ['Roboto:300,400,500,700', 'Material Icons'], // Replace with your desired Google Fonts and icons
  },
});


const vuetify = createVuetify({
  components,
  directives,
});

const httpLink = createHttpLink({
  uri: 'https://sp412b-763ef468411d.herokuapp.com/graphql',
});

const apolloClient = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
});

const app = createApp({
  setup() {
    provide(DefaultApolloClient, apolloClient);
  },
  render: () => h(App),
});

// Custom global method
app.config.globalProperties.cleanPhoneNumber = function(phoneNumber) {
  return phoneNumber.replace(/[\s-]/g, '');
};

app.use(vuetify);
app.use(router);

app.mount('#app');
